import type { TokenStore } from "@/domains/tokens"
import { LcAddress } from "@/domains/core"

import type { LockRewardStoreDAO, RawBribeData } from "./types"
import { LockRewardStore } from "./lock-reward-store"

/**
 * Convert raw ABI response to LockRewardStore DAO
 */
export function convertRawBribeDataToDAO(nftId: number, rawData: RawBribeData, token: TokenStore): LockRewardStoreDAO {
  // error! this is [pair, bribe, token]
  const [poolContract, bribeContract] = rawData.A

  const bribeAddress = new LcAddress(bribeContract)
  const poolAddress = new LcAddress(poolContract)

  const key = [nftId, bribeAddress.toString(), poolAddress.toString(), token.address.toString()].join("-")

  return {
    nftId,
    bribeAddress,
    key,
    poolAddress,
    amount: rawData.N,
    token,
  }
}
